export default "__VITE_ASSET__7bdb46e8__"